import Vue from 'vue';
import store from '../store';
import VueRouter from 'vue-router';
import { getSessionStorage } from '@/utils/stage';
import Home from '../views/index.vue';

Vue.use(VueRouter);

const routes = [
	{
		path: '/home',
		name: 'Init',
		component: () => import('../views/Init.vue'),
		meta: { title: 'title1' },
	},
	{
		path: '/fungoImg',
		name: 'Init',
		component: () => import('../views/Init.vue'),
		meta: { title: 'title1' },
	},
	{
		path: '/preamble',
		name: 'Init1',
		component: () => import('../views/Preamblecode/preambleInit.vue'),
		meta: { title: 'title1' },
	},
	{
		path: '/agreement',
		name: 'agreement',
		component: () => import('../views/agreement.vue'),
		meta: { title: '' },
	},
	{
		path: '/applogin',
		name: 'Applelogin',
		component: () => import('../views/AppleLogin.vue'),
		meta: { title: '苹果登陆' },
	},
	{
		path: '/',
		name: 'Init',
		redirect: '/home',
		component: Home,
		children: [
			{
				path: '/Privacy',
				name: 'Privacy',
				component: () => import('../views/Privacy.vue'),
				meta: { title: 'title21' },
			},
			{
				path: '/user',
				name: 'user',
				component: () => import('../views/user.vue'),
				meta: { title: 'title22' },
			},
			{
				path: '/sanFang',
				name: 'SanFang',
				component: () => import('../views/Sanfang/Home.vue'),
				meta: { title: 'title' },
			},
			{
				path: '/touristHome',
				name: 'Tourist',
				component: () => import('../views/Tourist/Home.vue'),
				meta: { title: 'title' },
			},
			{
				path: '/accountHome',
				name: 'AccountHome',
				component: () => import('../views/Account/AccountHome.vue'),
				meta: { title: 'title' },
			},
			{
				path: '/bindAccountTips',
				name: 'BindAccountTips',
				component: () =>
					import('../views/bindAccount/BindAccountTips.vue'),
				meta: { title: 'title5' },
			},
			{
				path: '/accountVerify',
				name: 'AccountVerify',
				component: () => import('../views/Account/AccountVerify.vue'),
				meta: { title: 'title4' },
			},
			{
				path: '/sanFaccountVerify',
				name: 'SanFAccountVerify',
				component: () =>
					import('../views/bindAccount/SfAccountVerify.vue'),
				meta: { title: 'title4' },
			},
			{
				path: '/changeEmail',
				name: 'changeEmail',
				component: () => import('../views/Account/changeEmail.vue'),
				meta: { title: 'title6' },
			},
			{
				path: '/changePassword',
				name: 'changePassword',
				component: () => import('../views/Account/ChangePsw.vue'),
				meta: { title: 'title7' },
			},
			{
				path: '/touristLogoffTips',
				name: 'TouristLogoffTips',
				component: () =>
					import('../views/LogOff/TouristLogoffTips.vue'),
				meta: { title: 'title8' },
			},
			{
				path: '/touristLogAgreement',
				name: 'TouristLogAgreement',
				component: () =>
					import('../views/LogOff/TouristLogAgreement.vue'),
				meta: { title: 'title20' },
			},
			{
				path: '/touristLogoffTips1',
				name: 'TouristLogoffTips1',
				component: () =>
					import('../views/LogOff/TouristLogoffTips1.vue'),
				meta: { title: 'title9' },
			},
			{
				path: '/setName',
				name: 'SetName',
				component: () => import('../views/Account/SetName.vue'),
				meta: { title: 'title10' },
			},
			{
				path: '/bindAccount',
				name: 'BindAccount',
				component: () => import('../views/bindAccount/BindAccount.vue'),
				meta: { title: 'title5' },
			},
			{
				path: '/bindAccount1',
				name: 'BindAccount1',
				component: () =>
					import('../views/bindAccount/BindAccount1.vue'),
				meta: { title: 'title5' },
			},
			{
				path: '/associatedAccount',
				name: 'AssociatedAccount',
				component: () =>
					import('../views/bindAccount/AssociatedAccount.vue'),
				meta: { title: 'title12' },
			},
			{
				path: '/bindAccountList',
				name: 'BindAccountList',
				component: () =>
					import('../views/bindAccount/BindAccountList.vue'),
				meta: { title: 'title5' },
			},
			{
				path: '/bindEmail',
				name: 'bindEmail',
				component: () => import('../views/bindAccount/BindEmail.vue'),
				meta: { title: 'title6' },
			},
			{
				path: '/logoffTips',
				name: 'LogoffTips',
				component: () => import('../views/LogOff/LogOffTips.vue'),
				meta: { title: 'title8' },
			},
			{
				path: '/logAgreement',
				name: 'LogAgreement',
				component: () => import('../views/LogOff/LogAgreement.vue'),
				meta: { title: 'title20' },
			},
			{
				path: '/logOffConfirm',
				name: 'LogOffConfirm',
				component: () => import('../views/LogOff/LogOffConfirm.vue'),
				meta: { title: 'title14' },
			},
			{
				path: '/logOffScuess',
				name: 'LogOffScuess',
				component: () => import('../views/LogOff/LogOffScuess.vue'),
				meta: { title: 'title15' },
			},
			{
				path: '/loginrecord',
				name: 'Loginrecord',
				component: () => import('../views/Account/LoginRecord.vue'),
				meta: { title: 'title16' },
			},
			// {
			// 	path: '/sfVerifyAccount',
			// 	name: 'SfVerifyAccount',
			// 	component: () => import('../views/Sanfang/sfVerifyAccount.vue'),
			// 	meta: { title: '账号登陆记录' },
			// },
			{
				path: '/kefu',
				name: 'kefu',
				component: () => import('../views/kefu.vue'),
				meta: { title: 'title3' },
			},
			{
				path: '/zmFAQ',
				name: 'kefu',
				component: () => import('../views/zmFAQ.vue'),
				meta: { title: 'title2' },
			},
			{
				path: '/FAQ',
				name: 'FAQ',
				component: () => import('../views/FAQ.vue'),
				meta: { title: 'title2' },
			},
			// {
			// 	path: '/changeScuess',
			// 	name: 'ChangeScuess',
			// 	component: () => import('../views/Account/ChangSuccess.vue'),
			// 	meta: { title: 'title19' },
			// },
			{
				path: '/success',
				name: 'Success',
				component: () => import('../views/Account/Success.vue'),
				meta: { title: '' },
			},
			{
				path: '/queryCenter',
				name: 'queryCenter',
				component: () => import('../views/queryCenter/index.vue'),
				meta: { title: '' },
			},
			{
				path: '/queryCard',
				name: 'queryCard',
				component: () => import('../views/queryCenter/queryCard.vue'),
				meta: { title: '' },
			},
			{
				path: '/queryDiamond',
				name: 'queryDiamond',
				component: () =>
					import('../views/queryCenter/queryDiamond.vue'),
				meta: { title: '' },
			},
			{
				path: '/qiyukf',
				name: 'qiyukf',
				component: () => import('../views/qiyukf.vue'),
				meta: { title: 'title3' },
			},
			{
				path: '/preamblelogin',
				name: 'Preamblecode',
				component: () => import('../views/Preamblecode/index.vue'),
				meta: { title: 'title23' },
			},
			{
				path: '/inputPreamble',
				name: 'inputPreamblecode',
				component: () =>
					import('../views/Preamblecode/inputPreamblecode.vue'),
				meta: { title: 'title24' },
			},
			{
				path: '/infoPreamble',
				name: 'infoPreamble',
				component: () =>
					import('../views/Preamblecode/infoPreamblecode.vue'),
				meta: { title: 'title24' },
			},
			{
				path: '/bindPreamble',
				name: 'bindPreamble',
				component: () =>
					import('../views/Preamblecode/bindPreamblecode.vue'),
				meta: { title: 'title25' },
			},
			{
				path: '/searchPreamble',
				name: 'searchPreamble',
				component: () =>
					import('../views/Preamblecode/searchPreamblecode.vue'),
				meta: { title: 'title24' },
			},
			{
				path: '/bindPreambleSuccess',
				name: 'bindPreambleSuccess',
				component: () =>
					import('../views/Preamblecode/bindPreambleSuccess.vue'),
				meta: { title: 'title25' },
			},
		],
	},
];

const router = new VueRouter({
	base: process.env.BASE_URL,
	routes,
});
router.beforeEach((to, from, next) => {
	//beforeEach是router的钩子函数，在进入路由前执行
	if (to.meta.title) {
		//判断是否有标题
		store.dispatch('info/setWebtitle', to.meta.title);
		console.log('to.meta.title', to.meta.title);
		// document.title = to.meta.title;
	} else if (to.name == 'Success') {
		const queryId = parseInt(to.query.id);
		const titleToken = JSON.parse(getSessionStorage('lang1'));
		console.log(to.name, titleToken);
		let title = '';
		switch (queryId) {
			case 1:
				title = 'title5';
				break;
			case 2:
				title = 'title11';
				break;
			case 3:
				title = 'title18';
				break;
			case 4:
				title = 'title7';
				break;
			case 5:
				title = 'title19';
				break;
			case 6:
				title = 'title6';
				break;
			case 7:
				title = 'title5';
				break;
		}
		document.title = titleToken.title;
		store.dispatch('info/setWebtitle', title);
	}

	next(); //执行进入路由，如果不写就不会进入目标页
});
export default router;
